import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import NewsroomDetailsPage from "./NewsroomDetailsPage";
import "./NewsroomPage.css";

const newsroomSections = [
  {
    title: "Blog",
    cta: "Read More",
    imageUrl: "https://blackroth-images.s3.ap-south-1.amazonaws.com/Blog.jpg",
    description:
      "Product thinking, engineering perspectives, and company stories from BlackRoth.",
    href: "/newsroom/blog",
  },
  {
    title: "Letters from the CEO",
    cta: "Read More",
    imageUrl: "https://blackroth-images.s3.ap-south-1.amazonaws.com/Ceo_Letter.png",
    description:
      "Leadership reflections on growth, innovation, and the vision shaping BlackRoth.",
    href: "/newsroom?section=letters",
  },
 
];

const newsroomTitleLines = [
  ["N"],
  ["e"],
  ["w"],
  ["s"],
  ["r", "o", "o", "m"],
];
const LETTER_DROP_DURATION_MS = 680;
const LETTER_STAGGER_MS = 180;

const DefaultNewsroomPage = () => {
  const [animate, setAnimate] = useState(false);

  const isInternalRoute = (href) => href.startsWith("/");

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimate(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="page-wrapper">
      <div className="newsroom-container">
        <div className="newsroom-top-bar">
          <div className="back-link">
            <Link to="/">&larr; Back to Home</Link>
          </div>

          <nav className="newsroom-top-links" aria-label="Newsroom categories">
            {newsroomSections.map((section) =>
              isInternalRoute(section.href) ? (
                <Link key={section.title} to={section.href}>
                  {section.title}
                </Link>
              ) : (
                <a key={section.title} href={section.href}>
                  {section.title}
                </a>
              )
            )}
          </nav>
        </div>

        <section className="newsroom-hero">
          <div>
            <h1 className={animate ? "slide-in active" : "slide-in"}>
              {newsroomTitleLines.map((line, lineIndex) => (
                <span
                  key={`line-${lineIndex}`}
                  className="newsroom-title-line"
                >
                  {line.map((letter, letterIndex) => {
                    const index =
                      newsroomTitleLines
                        .slice(0, lineIndex)
                        .reduce((count, currentLine) => count + currentLine.length, 0) +
                      letterIndex;

                    return (
                      <span
                        key={`${letter}-${index}`}
                        className="newsroom-title-letter-slot"
                      >
                        <span
                          className={animate ? "newsroom-title-letter is-visible" : "newsroom-title-letter"}
                          style={{
                            animationDuration: `${LETTER_DROP_DURATION_MS}ms`,
                            animationDelay: `${index * LETTER_STAGGER_MS}ms`,
                          }}
                        >
                          {letter}
                        </span>
                      </span>
                    );
                  })}
                </span>
              ))}
            </h1>
          </div>

          <p className={animate ? "newsroom-intro active" : "newsroom-intro"}>
            The latest news, press releases, blogs, and leadership updates from
            BlackRoth.
          </p>
        </section>

        <section className="newsroom-grid" aria-label="Newsroom categories">
          {newsroomSections.map((section) => (
            <article
              key={section.title}
              id={section.title.toLowerCase().replace(/\s+/g, "-")}
              className="newsroom-card"
            >
              <div
                className={`newsroom-card-visual newsroom-card-visual--${section.variant}${section.imageUrl ? " newsroom-card-visual--image" : ""}`}
              >
                {section.imageUrl ? (
                  <img
                    src={section.imageUrl}
                    alt={`${section.title} newsroom`}
                    className="newsroom-card-image"
                  />
                ) : (
                  <>
                    <span className="visual-badge">{section.badge}</span>
                    <span className="visual-text">{section.title}</span>
                  </>
                )}
              </div>

              <div className="newsroom-card-body">
                <h2>{section.title}</h2>
                <p>{section.description}</p>

                {isInternalRoute(section.href) ? (
                  <Link to={section.href} className="newsroom-link">
                    <span>{section.cta}</span>
                    <span>+</span>
                  </Link>
                ) : (
                  <button className="newsroom-link">
                    <span>{section.cta}</span>
                    <span>+</span>
                  </button>
                )}
              </div>
            </article>
          ))} 
        </section>
      </div>
    </div>
  );
};

const NewsroomPage = () => {
  const location = useLocation();
  const section = new URLSearchParams(location.search).get("section");

  if (
   
    section === 'letters'
    
  ) {
    return <NewsroomDetailsPage />;
  }

  return <DefaultNewsroomPage />;
};

export default NewsroomPage;



 
